import BrazeService from '~/services/BrazeService';
import useModalStore from '~/stores/modalStore';
import ImageUrlsConstants from '~/config/ImageUrls.constants';

export enum BrazeInAppMessageBannerThemeType {
  PREMIUM = 'PREMIUM',
  INFO = 'INFO',
  ERROR = 'ERROR',
  AI = 'AI',
}

enum BrazeInAppMessageButtonActionType {
  NONE = 'NONE',
  URI = 'URI',
}

export interface BrazeInAppMessageButton {
  text: string,
  action: () => void,
  type: BrazeInMessageButtonType,
}

export enum BrazeInMessageButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export interface BrazeInAppMessageType {
  theme: BrazeInAppMessageBannerThemeType,
  buttons: Array<BrazeInAppMessageButton>,
  image?: string,
  message?: string,
  title?: string,
  inAppMessageData: any,
}

export function getBrazeInAppMessageData(data: any): BrazeInAppMessageType {
  return {
    theme: getThemeName(data?.extras?.content_theme),
    buttons: data?.buttons?.map((button: any, index: number) => {
      return getBrazeButtonData(data, button, index);
    }),
    image: data?.imageUrl ?? '',
    message: data?.message,
    title: data?.header,
    inAppMessageData: data,
  };
}

function getBrazeButtonData(brazeData: any, buttonData: any, index: number): BrazeInAppMessageButton {
  switch (buttonData?.clickAction) {
    case BrazeInAppMessageButtonActionType.NONE:
      return {
        text: buttonData?.text,
        action: () => {
          BrazeService.logInAppMessageButtonClick(brazeData, buttonData);
          useModalStore().hideBrazeInAppBanner();
        },
        type: BrazeInMessageButtonType.SECONDARY,
      };
    case BrazeInAppMessageButtonActionType.URI:
      return {
        text: buttonData?.text,
        action: () => {
          const url = new URL(buttonData?.uri);
          window.open(url.toString(), '_blank');
          BrazeService.logInAppMessageButtonClick(brazeData, buttonData);
          useModalStore().hideBrazeInAppBanner();
        },
        type: index === 0 ? BrazeInMessageButtonType.PRIMARY : BrazeInMessageButtonType.SECONDARY,
      };
    default:
      return {
        text: buttonData?.text,
        action: () => {
          useModalStore().hideBrazeInAppBanner();
        },
        type: BrazeInMessageButtonType.SECONDARY,
      };
  }
}

export function getThemeName(themeString: string): BrazeInAppMessageBannerThemeType {
  return themeString
    ? themeString as BrazeInAppMessageBannerThemeType
    : BrazeInAppMessageBannerThemeType.INFO;
};
export const brazeBannerStyleMap = {
  [BrazeInAppMessageBannerThemeType.AI]: {
    backgroundStyle: 'ai-bg-image',
    titleStyle: 'text-ds-light-500',
    descriptionStyle: 'text-ds-light-500-80',
    Icon: ImageUrlsConstants.BRAZE_AI_BANNER_ICON,
    crossIconStyle: 'text-ds-light-500',
    buttonStyles: {
      [BrazeInMessageButtonType.PRIMARY]: 'bg-ds-light-500 text-ds-dark-400 hover:bg-ds-light-300 active:bg-ds-light-200',
      [BrazeInMessageButtonType.SECONDARY]: 'bg-transparent text-ds-light-500 border-1 rounded border-ds-light-500-20 hover:border-ds-light-500-40 active:border-ds-light-500-60',
    },
  },
  [BrazeInAppMessageBannerThemeType.ERROR]: {
    backgroundStyle: 'bg-ds-fail-100',
    titleStyle: 'text-ds-dark-400',
    descriptionStyle: 'text-ds-dark-200',
    Icon: ImageUrlsConstants.BRAZE_BANNER_ERROR_ICON,
    crossIconStyle: 'text-ds-dark-400',
    buttonStyles: {
      [BrazeInMessageButtonType.PRIMARY]: 'bg-ds-lilac-500 text-ds-light-500 hover:bg-lilac-light active:bg-lilac-dark',
      [BrazeInMessageButtonType.SECONDARY]: 'bg-ds-lilac-100 text-ds-lilac-500 border-1 rounded border-ds-lilac-500-40 hover:text-lilac-light active:text-lilac-dark',
    },
  },
  [BrazeInAppMessageBannerThemeType.INFO]: {
    backgroundStyle: 'bg-ds-info-100',
    titleStyle: 'text-ds-dark-400',
    descriptionStyle: 'text-ds-dark-200',
    Icon: ImageUrlsConstants.BRAZE_BANNER_INFO_ICON,
    crossIconStyle: 'text-ds-dark-400',
    buttonStyles: {
      [BrazeInMessageButtonType.PRIMARY]: 'bg-ds-info-500 text-ds-light-500 hover:bg-ds-info-400 active:bg-ds-info-600',
      [BrazeInMessageButtonType.SECONDARY]: 'bg-transparent text-ds-info-500-40 border-1 rounded border-ds-info-500-40 hover:bg-ds-info-500-40',
    },
  },
  [BrazeInAppMessageBannerThemeType.PREMIUM]: {
    backgroundStyle: 'bg-ds-super-100',
    titleStyle: 'text-ds-dark-400',
    descriptionStyle: 'text-ds-dark-200',
    Icon: ImageUrlsConstants.BRAZE_BANNER_PREMIUM_ICON,
    crossIconStyle: 'text-ds-dark-400',
    buttonStyles: {
      [BrazeInMessageButtonType.PRIMARY]: 'bg-ds-lilac-500 text-ds-light-500 hover:bg-lilac-light active:bg-lilac-dark',
      [BrazeInMessageButtonType.SECONDARY]: 'bg-ds-lilac-100 text-ds-lilac-500 border-1 rounded border-ds-lilac-500-40 hover:text-lilac-light active:text-lilac-dark',
    },

  },
};
